import React from 'react'
import PropTypes from 'prop-types'

class FrequentQuestions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      collapsibleOpen: false,
      collapsibleId: null
    }
  }

  handleClick = (index) => {
    this.setState({
      collapsibleOpen: !this.state.collapsibleOpen,
      collapsibleId: index
    });
  }

  render() {
    return(
      <section className="section-faq purple-bg" id="section-faq">
        <div className="container container-1010">
          <div className="text-center">
            <h2 className="h-80 p-white m-0">Frequently Asked Questions</h2>
          </div>
          <div className="faq mt-70" id="accordion">
            {this.props.data.map(({ question, answer }, index) => (
              <div className="collapsible-group">
                <div className="collapsible-heading" role="tab" id="headingOne">
                  <a
                    role="button"
                    className={this.state.collapsibleOpen && this.state.collapsibleId === index ? '' : 'collapsed'}
                    data-parent="#accordion"
                    href="javascript:void(0)"
                    onClick={() => this.handleClick(index)}
                  >
                    {question}<span className="collapsible-sign"></span>
                  </a>
                </div>
                <div id={index} className={this.state.collapsibleOpen && this.state.collapsibleId === index ? 'collapsible-collapse collapse in' : 'collapsible-collapse collapse'}>
                  <div className="collapsible-body" dangerouslySetInnerHTML={{ __html: answer }}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }
}

FrequentQuestions.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
}

export default FrequentQuestions



// WEBPACK FOOTER //
// ./src/components/FrequentQuestions.js